import type { Course } from "@/core/types";
import { modulAbschnitte } from "./abschnitte";
import { modulAnimationen } from "./animationen";
import { modulBarrierefreiheit } from "./barrierefreiheit";
import { modulBilder } from "./bilder";
import { modulExport } from "./export";
import { modulFolien } from "./folien";
import { modulMaster } from "./master";
import { modulPlatzhalter } from "./platzhalter";
import { modulPraesentieren } from "./praesentieren";
import { modulTabellen } from "./tabellen";
import { modulText } from "./text";
import { modulVorlagen } from "./vorlagen";
import { modulBildschirmpraesentation } from "./bildschirmpraesentation";
import { modulInteraktiv } from "./interaktiv";
import { modulUeberpruefen } from "./ueberpruefen";

/**
 * PowerPoint-Komplettkurs.
 *
 * Eigenständiger Kurs neben dem Word-Kurs, kein Modul davon: PowerPoint hat ein
 * anderes Datenmodell (Folien und Formen statt Absätzen) und braucht eine eigene
 * Zugriffsschicht unter src/office/powerpoint/.
 *
 * Zwei Gedanken ziehen sich durch alle Module und prägen die Prüfungen:
 *
 * 1. Layouts und Platzhalter statt frei gezogener Textfelder. Das ist die
 *    Entsprechung zu „Formatvorlagen statt direkter Formatierung“ im Word-Kurs
 *    und über Shape.placeholderFormat beziehungsweise Shape.type prüfbar.
 * 2. Eine Folie ist kein Dokument. Stichpunkte statt Fließtext – prüfbar über
 *    die Textmenge je Platzhalter.
 */
export const powerPointKurs: Course = {
  id: "powerpoint-grundlagen",
  host: "PowerPoint",
  title: "PowerPoint Komplettkurs",
  summary:
    "Microsoft PowerPoint von Grund auf: von der ersten Folie bis zu Folienmaster, " +
    "Übergängen, Animationen, interaktiven Folien, Vorlagen und einer Präsentation, die " +
    "auch ohne Vortragende verständlich bleibt.",
  level: "Komplettkurs",
  modules: [
    modulFolien,
    modulPlatzhalter,
    modulText,
    modulBilder,
    modulTabellen,
    modulMaster,
    modulPraesentieren,
    modulBarrierefreiheit,
    modulAnimationen,
    modulBildschirmpraesentation,
    modulInteraktiv,
    modulAbschnitte,
    modulUeberpruefen,
    modulVorlagen,
    modulExport,
  ],
};
